export default __webpack_public_path__ + "static/media/back_jump.7af92eb1.svg";